"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisplayImageCheckDescriptionFormat = DisplayImageCheckDescriptionFormat;

var _noimage = _interopRequireDefault(require("../../images/noimage.svg"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _styles = require("@eig-builder/core-ui/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    imageWrapper: {
      "float": 'left'
    },
    image: {
      height: "".concat(theme.spacing(9), "px")
    },
    displayName: {
      marginLeft: "".concat(theme.spacing(17), "px"),
      verticalAlign: 'top',
      paddingTop: "".concat(theme.spacing(2.5), "px"),
      paddingLeft: "".concat(theme.spacing(1.25), "px")
    }
  };
});

function DisplayImageCheckDescriptionFormat(params) {
  var classes = useStyles(params);
  var urlImage = _noimage["default"];
  var record = params.data;

  if (record && record.images && record.images.length >= 1) {
    urlImage = record.images[0];
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "display-image-check-description"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("image-check-wrapper ".concat(classes.imageWrapper), {
      active: false
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "display-image"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.image,
    src: urlImage
  }))), record.displayName && /*#__PURE__*/_react["default"].createElement("div", {
    className: "display-description text-truncate ".concat(classes.displayName)
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: record.displayName
  })));
}